import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class WorkerApi extends Requestor {
    // 워커 리스트 조회
    getWorkers(params = {}) {
        const url = '/api/v1/workers';
        return this.get({
            url,
            params,
        });
    }
    // 워커 단일 조회
    getWorker(workerCode, params = {}) {
        return this.get({
            url: `/api/v1/workers/${workerCode}`,
            params,
        });
    }
    permitWorker(data = {}) {
        return this.put({
            url: '/api/v1/workers/permission',
            data,
        });
    }
    postWorker(data = {}) {
        return this.post({
            url: '/api/v1/workers',
            data,
        });
    }
    postPhoneExistence(data = {}) {
        return this.post({
            url: '/api/v1/workers/phone/existence',
            data,
        });
    }
    postHubEmployeeNumberExistence(data = {}) {
        return this.post({
            url: '/api/v1/workers/hub-employee-number/existence',
            data,
        });
    }
    putWorkerDetail(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}`,
            data,
        });
    }
    putWorkersBasic(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}/basic`,
            data,
        });
    }
    putWorkersWork(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}/work`,
            data,
        });
    }
    putWorkersPrivacy(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}/privacy`,
            data,
        });
    }
    putWorkersPermission(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}/permission`,
            data,
        });
    }
    // 일괄설정
    putWorkers(workerCode, data = {}) {
        return this.put({
            url: `/api/v1/workers/${workerCode}`,
            data,
        });
    }
    /**
     * 라이더 월별 출근표
     */
    getWorkerMonthlyAttendance(params = {}) {
        return this.get({
            url: '/api/v1/workers/monthly-attendance',
            params,
        });
    }
    /**
     * 라이더 수익 정보 조회 - (RestDoc: worker 수익 정보 조회)
     */
    getWorkerProfitStatistic(params = {}) {
        return this.get({
            url: '/api/v1/workers/stat/profit',
            params,
        });
    }
}
export default new WorkerApi(clientInstance);
